import { PAYMENT_TYPES } from "../stores/VacuumStore/VacumStore.types"

export interface VacuumActivation {
  id: string,
  status: string,
  time_on: number,
  stationCode: string
}

export interface TotemTransaction {
  amount: string,
  paymentType: PAYMENT_TYPES,
  totemId: string,
}

export interface TotemOrder {
  price: number;
  time: number;
  paymentType: PAYMENT_TYPES;
  taxId: string;
  vacuumCleanerId: string;
  totemId: string;
  cieloTransactionId: string;
}

export interface PaymentOption {
  type: PAYMENT_TYPES;
  title: string;
}

export interface Receipt {
  email: string;
  paymentId: string;
}
export interface TransactionResponse {
  message: string;
  topic: string;
  timestamp: string;
}

export interface TransactionReturn {
  success: boolean;
  data: TransactionResponse;
}

export interface TransactionError {
  success: boolean;
  error: any;
  data?: undefined;
}

export interface EventSourceConfirmation {
  id: string;
  totemId: string;
  paymentId: string;
  cieloTransactionId: string;
  responseJson: string;
  timestamp: string;
}

export enum VACUUM_STATUS {
  LIGADO = "LIGADO",
  DESLIGADO = "DESLIGADO",
}

export interface VacuumOption {
  id: string
  deviceId: string;
  serialNumber: string | null;
  name: string;
  station: string;
  status: VACUUM_STATUS;
  pricePerMinute: number;
}

export interface VacuumCleaner {
  deviceId: string,
  name: string,
  station: string
}